import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../ts/Glob';

import { INotification, IMessage } from '../../ts/stores/NotificationsStore';

interface INotificationProperties {
    id: number;
    value: INotification;
    glob: IGlob;
    showInPopup?: boolean;
}

export function Notification(props: INotificationProperties) {
    const timer = React.useRef(null);

    React.useEffect(() => {
        const { options } = props.value || {};
        const noTimer =
            options.manualDestroy ||
            (options.progress && options.deferred != null) ||
            props.value.type === 'fail' ||
            props.value.widgetRunTimeID != null;

        if (timer.current != null) {
            clearTimeout(timer.current);
        }

        if (!noTimer) {
            let showTime = options.showTime;

            if (showTime == null || showTime < 0) {
                showTime = 5000;
            }

            timer.current = setTimeout(() => {
                props.glob.AppActions.notificationClean(props.id);
            }, showTime);
        }

        if (options.progress) {
            options.deferred.done(() => {
                props.glob.AppActions.notificationClean(props.id);
            });
        }

        return () => {
            if (timer.current != null) {
                clearTimeout(timer.current);
            }
        };
    }, [props.value.messages]);

    const hanldeOnClick = (e) => {
        if (props.value.options.deferred != null) {
            props.value.options.deferred.reject();
        }

        props.glob.AppActions.notificationClean(props.id);

        e.stopPropagation();
        e.preventDefault();
    };

    const getShowDetailsHandler = (messageObj: IMessage) => {
        return (e) => {
            props.glob.DialogActions.createDialog(
                messageObj.content,
                '',
                () => {},
                () => {},
                () => {},
                'confirm',
                {
                    content: (
                        <div className="platform-notification-details">
                            <pre style={{ display: 'contents' }}>{messageObj.details}</pre>
                        </div>
                    ),
                    confirmTitle: null,
                    cancelTitle: null,
                    closeTitle: 'OK'
                }
            );
        };
    };

    const handleOnErrorMessageClick = () => {
        if (props.value.widgetRunTimeID != null) {
            props.glob.AppActions.cleanWidgetNotifications(props.value.widgetRunTimeID);
        }
    };

    const { options, type } = props.value;
    const useCloseButton = options.manualDestroy || options.progress;
    const freeNotification = props.value.widgetRunTimeID == null && props.showInPopup !== true;

    let closeButtonElement: React.JSX.Element;

    if (freeNotification) {
        if (useCloseButton) {
            closeButtonElement = <span className="btn-close glyphicon glyphicon-remove" onClick={hanldeOnClick}></span>;
        }
    }

    let progressElement: React.JSX.Element;

    if (options.progress) {
        progressElement = <div className="loader-spinning"></div>;
    }

    return (
        <div
            className={'platform-notification ' + type}
            onClick={freeNotification && !useCloseButton ? hanldeOnClick : null}
        >
            {closeButtonElement}

            <div className="platform-notification-inner">
                {_.map(props.value.messages, (messageObj, i) => {
                    // let count = '';

                    // if (type === 'fail' && messageObj.count > 1) {
                    //     count = `(${ messageObj.count }) `;
                    // }

                    let details: React.JSX.Element;

                    if (messageObj.details != null && messageObj.details !== '') {
                        details = (
                            <div
                                key={'detail-' + i}
                                className="btn details-button btn-xs btn-default"
                                onClick={getShowDetailsHandler(messageObj)}
                            >
                                {'details'}
                            </div>
                        );
                    }

                    let reactContent: React.JSX.Element;

                    if (messageObj.reactContent != null) {
                        reactContent = <div key={'rc_' + i}>{messageObj.reactContent}</div>;
                    }

                    let className = 'main-message';

                    if (messageObj.content != null && messageObj.content.indexOf('\n') < 0) {
                        className += ' center';
                    }

                    return [
                        <div
                            className={className}
                            key={i}
                            dangerouslySetInnerHTML={{
                                __html: messageObj.content
                            }}
                            onClick={handleOnErrorMessageClick}
                        />,
                        reactContent,
                        details
                    ];
                })}

                {progressElement}
            </div>
        </div>
    );
}
